<template>
<modal size="medium" @close="close">
	<template #header>
		<h3>{{ $t("Delete Warehouse") }}</h3>
	</template>
	<template #body>
		<span>
			{{  $t('Are You Sure want to delete warehouse with name : ')  }} <span class="font-weight-bold">
				{{ warehouse.label }}
			</span>
		</span>
	</template>
	<template #footer>
		<!-- Cancel -->
		<button type="button" class="btn btn-light" @click="close">
			{{ $t("Cancel") }}
		</button>
		<!-- Submit -->
		<button
			class="btn btn-danger"
			:class="{ 'is-loading': isLoading }"
			@click="submit"
		>
			<span>{{ $t("Delete Warehouse") }}</span>
		</button>
	</template>
</modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import warehouseApi from '@/api/warehouse';

export default {
	name: 'DeleteWarehouse',
	props: {
		warehouse: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			isLoading: false,
		};
	},
	methods: {
		...mapActions({
			deleteWarehouse: 'warehouse/deleteWarehouse',
		}),
		close() {
			this.$emit('close');
		},
		submit() {
			const callback = (response) => {
				const warehouse = response.data;
				this.$emit('set', warehouse);
				this.close();
			};
			const err = (e) => {
				console.log(e);
			};
			warehouseApi.delete(this.warehouse._id, callback, err);
		},
	},
};
</script>

<style></style>
